@if (visible) {
  <div class="screen-loader" role="dialog" aria-modal="true" aria-busy="true">
    <div class="screen-loader__backdrop"></div>
    <div class="screen-loader__panel">
      <div class="screen-loader__spinner" aria-hidden="true"></div>
      <p class="screen-loader__message">{{ message }}</p>
    </div>
  </div>
}
